import styles from "../../../../MapMonitoring/components/AddMarkerModal/AddIncidentModal.module.css";
import React, { useEffect, useMemo, useReducer } from "react";
import { TextField } from "@mui/material";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";
import { typeContainerPlatformsService } from "../../../../../services/guide/typeContainerPlatforms-service";
import { useFetchGetTypeCPById } from "../../../../../hooks/guide/useFetchGetTypeCPById";
import {
    CreateTypeContainerPlatforms,
    UpdateTypeContainerPlatforms,
} from "../../../../../types/api/guide/typeContainerPlatform.types";

type FormState = {
    name: string;
};

type Action =
    | { type: "SET_FIELD"; name: keyof FormState; value: any }
    | { type: "SET_All"; payload: FormState }
    | { type: "RESET" };

const initialState: FormState = {
    name: "",
};

const reducer = (state: FormState, action: Action): FormState => {
    switch (action.type) {
        case "SET_FIELD":
            return { ...state, [action.name]: action.value };

        case "SET_All":
            return { ...action.payload };

        case "RESET":
            return initialState;

        default:
            return state;
    }
};

interface TypeCPAddModalProps {
    onClose: () => void;
    refetchData: () => void;
    id: string;
}

export const TypeCPAddModal = ({ onClose, refetchData, id }: TypeCPAddModalProps) => {
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();

    const isEdit = Boolean(id);
    const { data: typeCP } = useFetchGetTypeCPById(id);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!typeCP) return;

        dispatch({
            type: "SET_All",
            payload: {
                name: typeCP.name ?? "",
            },
        });
    }, [typeCP]);

    const handleValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        dispatch({ type: "SET_FIELD", name: name as keyof FormState, value });
    };

    const canSave = useMemo(() => {
        return Boolean(state.name.trim());
    }, [state.name]);

    const handleSave = async () => {
        try {
            if (!typeCP) {
                const payload: CreateTypeContainerPlatforms = {
                    name: state.name.trim(),
                };

                await typeContainerPlatformsService.create(payload);
                showSuccess("Тип КП создан");
            } else {
                const payload: UpdateTypeContainerPlatforms = {
                    id: typeCP.id,
                    name: state.name.trim(),
                };

                await typeContainerPlatformsService.update(typeCP.id, payload);
                showSuccess("Тип КП обновлен");
            }

            refetchData();
            onClose();
        } catch (e: any) {
            showError(e?.response?.data ?? "Ошибка при обновлении/добавлении КП");
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        {isEdit ? "Редактировать тип КП" : "Добавить тип КП"}
                    </h3>
                    <button className={styles.modalClose} onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className={styles.modalBody}>
                    <div className={styles.modalField}>
                        <div className={styles.modalLabel}>Название</div>
                        <div className={styles.modalCoords}>
                            <TextField
                                name="name"
                                value={state.name}
                                onChange={handleValue}
                                fullWidth
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        Отмена
                    </button>

                    <button
                        className={`${styles.modalButton} ${styles.modalButtonPrimary}`}
                        onClick={handleSave}
                        disabled={!canSave}
                        style={{ opacity: canSave ? 1 : 0.6 }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>

            <SnackbarComponent />
        </div>
    );
};